import { jsx as _jsx } from "react/jsx-runtime";
const DropdownItem = ({ onClick, children }) => {
    return (_jsx("li", Object.assign({ onClick: () => onClick && onClick() }, { children: _jsx("a", Object.assign({ className: "dropdown-item", style: { cursor: 'pointer' } }, { children: children })) })));
};
export default DropdownItem;
